import { fileExtension, fileTypeIdentity, fileTypeLabel, formatFileSize, formatUploadedDate, previewKindFor, uploadedSortValue } from '@features/Attachments/utils/fileFormatting';
import { SOURCE_ATTACHMENT } from '../constants';
/** Display text for a row's source, e.g. "Attachment", "Report". */
export function sourceLabel(source, translateFn) {
    return translateFn(`source.${source}`);
}
/**
 * The generated sources have no filename of their own, so the usual "derive the type from the real
 * filename" rule has nothing to work with. They are always rendered PDFs, and the server says so
 * in `contentType` -- so a synthetic `.pdf` name gives the type column, type filter, sort and
 * preview something correct to read, rather than falling back to the display name and rendering
 * every generated row as type "File".
 */
function typeSourceFor(api) {
    var _a;
    if ((_a = api.fileName) === null || _a === void 0 ? void 0 : _a.trim())
        return api.fileName;
    if (api.source !== SOURCE_ATTACHMENT && api.contentType === 'application/pdf')
        return `${api.name}.pdf`;
    return api.name;
}
/** Enriches one API row with every display/filter/sort value the surface and columns need. */
export function toWorkOrderAttachmentRow(api, translateFn) {
    var _a, _b;
    const sizeBytes = (_a = api.fileSize) !== null && _a !== void 0 ? _a : 0;
    const typeSource = typeSourceFor(api);
    // A generated document has no timestamp of its own when the Report or Proposal behind it is
    // gone; the surface still has to sort and render it rather than print "Invalid Date".
    const createdAt = (_b = api.createdAt) !== null && _b !== void 0 ? _b : '';
    return {
        id: api.id,
        source: api.source,
        recordId: api.recordId,
        sourceLabel: sourceLabel(api.source, translateFn),
        name: api.name,
        createdAt,
        uploadedLabel: createdAt ? formatUploadedDate(createdAt) : '',
        uploadedSortValue: createdAt ? uploadedSortValue(createdAt) : 0,
        sizeBytes,
        // Only uploaded attachments carry bytes. Showing "0 Bytes" for a generated document would be
        // a statement about its size, and a false one.
        sizeLabel: api.fileSize == null ? '' : formatFileSize(sizeBytes),
        showOnReport: api.showOnReport,
        editable: api.editable,
        selectable: api.selectable,
        removeKind: api.removeKind,
        typeLabel: fileTypeLabel(typeSource, translateFn),
        typeFilterValue: fileTypeIdentity(typeSource),
        previewKind: previewKindFor(typeSource),
        extension: fileExtension(typeSource),
        url: api.url
    };
}
